import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { Box } from '@wix/design-system';
import { AppContextProvider } from '../AppLoader';
import { ThemedText } from '../ThemedComponents';

export const Recaptcha: React.FC<{ id?: string }> = observer(({ id }) => {
  const {
    rootStore: {
      captchaStore: {
        RECAPTCH_ENTERPRISE_ELEMENT_ID,
        showCheckboxValidationMessage,
      },
    },
  } = useContext(AppContextProvider);
  const { t } = useTranslation();
  return (
    <Box direction="vertical" align="center" gap="6px">
      <div
        style={{ display: 'flex', justifyContent: 'center' }}
        id={id ?? RECAPTCH_ENTERPRISE_ELEMENT_ID}
      ></div>
      {showCheckboxValidationMessage && (
        <ThemedText skin="error" size="small">
          {t('login.captcha.select_checkbox', {
            defaultValue: 'Select the "I\'m not a robot" checkbox to continue.',
          })}
        </ThemedText>
      )}
    </Box>
  );
});
